import { Component, Inject, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';

export class asignRoleActionError implements ErrorStateMatcher {
  isErrorState(
    control: FormGroup | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-asign-role-or-action-create-modal',
  templateUrl: './asign-role-or-action-create-modal.component.html',
  standalone: true,
})
export class AsignRoleOrActionCreateModalComponent implements OnInit {
  formBuilder = inject(FormBuilder);
  public operation: string = '';
  public actionForm!: FormGroup;
  matcher = new asignRoleActionError();

  // TODO: de acá hacia abajo codigo inutil, se debe conocer el funcionamiento de las tablas

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    if (this.data.action?.id) {
      this.operation = 'Modificar';
      this.actionForm = this.formBuilder.group({
        id: [this.data.action?.id],
        name: [this.data.action?.name, Validators.required],
        code: [this.data.action?.code, Validators.required],
        description: [this.data.action?.description, Validators.required],
        type: [this.data.action?.type, Validators.required],
      });
      console.log(this.actionForm.controls);
    } else {
      this.operation = 'Crear';
      this.actionForm = this.formBuilder.group({
        id: ['0'],
        name: ['', Validators.required],
        code: ['', Validators.required],
        description: ['', Validators.required],
        type: ['', Validators.required],
      });
    }
  }

  get id_() {
    return this.actionForm.get('id');
  }
}
